import { render } from "./GroupsView.vue?vue&type=template&id=49ad51a4&scoped=true"
import script from "./GroupsView.vue?vue&type=script&lang=js"
export * from "./GroupsView.vue?vue&type=script&lang=js"

import "./GroupsView.vue?vue&type=style&index=0&id=49ad51a4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ad51a4"]])

export default __exports__